/** 성명 + 생년월일 + 입사일 기준 중복. 입사일이 다른 재입사는 별도 이력 */

const toDateOnly = (val: string | null | undefined) => {
  if (!val) return '';
  const s = String(val).trim().split('T')[0].split(' ')[0];
  if (!s || s === '0000-00-00' || s === '9999-12-31') return '';
  return s;
};

export const getEmployeeDuplicateKey = (row: {
  clci_name?: string;
  clci_birth_date?: string;
  clci_work_start_date?: string;
}) => {
  const name = String(row.clci_name || '').trim().toLowerCase();
  const birth = toDateOnly(row.clci_birth_date);
  const start = toDateOnly(row.clci_work_start_date);
  if (!name || !birth) return '';
  return `${name}|${birth}|${start}`;
};

export const getEmployeeRowIdentity = (row: { clci_source?: string; clci_idx?: number }) =>
  `${row.clci_source || 'auto'}-${row.clci_idx}`;

export const findEmployeeDuplicate = (
  list: any[],
  candidate: {
    clci_name?: string;
    clci_birth_date?: string;
    clci_work_start_date?: string;
  },
  excludeIdentity?: string | null
) => {
  const key = getEmployeeDuplicateKey(candidate);
  if (!key) return null;
  const flat = list.flatMap((row) => {
    const lines = Array.isArray(row?.employments) ? row.employments : [];
    if (!lines.length) return [row];
    return lines.map((line: { clci_source?: string; clci_idx?: number; clci_work_start_date?: string }) => ({
      ...row,
      clci_source: line.clci_source,
      clci_idx: line.clci_idx,
      clci_work_start_date: line.clci_work_start_date,
    }));
  });
  return (
    flat.find((row) => {
      if (excludeIdentity && getEmployeeRowIdentity(row) === excludeIdentity) return false;
      return getEmployeeDuplicateKey(row) === key;
    }) || null
  );
};

export const DUPLICATE_EMPLOYEE_MESSAGE =
  '같은 입사일의 사원이 이미 있습니다. 퇴사 후 재입사는 새 입사일로 한 번 더 등록해 주세요.';
